import { apiClient } from '@/api/client'
import type { FlujoEmail, ContactoRow, EjecucionFlujo } from '../types'

const BASE = '/doppler'

export const emailFlowsApi = {
  listar: () =>
    apiClient.get<FlujoEmail[]>(`${BASE}/flows/`).then((r) => r.data),

  obtener: (id: number) =>
    apiClient.get<FlujoEmail>(`${BASE}/flows/${id}/`).then((r) => r.data),

  crear: (payload: { nombre: string; descripcion?: string; definicion_json?: object }) =>
    apiClient.post<FlujoEmail>(`${BASE}/flows/`, payload).then((r) => r.data),

  actualizar: (id: number, payload: Partial<{ nombre: string; descripcion: string; definicion_json: object }>) =>
    apiClient.put<FlujoEmail>(`${BASE}/flows/${id}/`, payload).then((r) => r.data),

  eliminar: (id: number) =>
    apiClient.delete(`${BASE}/flows/${id}/`),

  importarContactos: (flujoId: number, contactos: ContactoRow[]) =>
    apiClient.post<{ creados: number; ignorados: number; doppler_list_id: string }>(
      `${BASE}/flows/${flujoId}/contacts/`,
      { contactos },
    ).then((r) => r.data),

  ejecutar: (flujoId: number) =>
    apiClient.post<EjecucionFlujo>(`${BASE}/flows/${flujoId}/execute/`).then((r) => r.data),

  estadoEjecucion: (ejecucionId: number) =>
    apiClient.get(`${BASE}/executions/${ejecucionId}/status/`).then((r) => r.data),
}
